import { render, staticRenderFns } from "./ShiftOrder.vue?vue&type=template&id=1dfb4de0&scoped=true"
import script from "./ShiftOrder.vue?vue&type=script&lang=js"
export * from "./ShiftOrder.vue?vue&type=script&lang=js"
import style0 from "./ShiftOrder.vue?vue&type=style&index=0&id=1dfb4de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfb4de0",
  null
  
)

export default component.exports